import { useEffect, useRef } from 'react'
export function usePrevious(value, condition) {
  // SLAM-1938: React 19 requires an initial value for useRef, so we pass undefined. This is valid on React 18 and does not change behaviour.
  const ref = useRef<any>(undefined)
  useEffect(() => {
    if (condition) {
      ref.current = value
    }
  }, [value])
  return ref.current
}
